import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

interface PaginationLinksProps {
  nextPageUrl?: string | null;
  prevPageUrl?: string | null;
}

export const PaginationLinks: React.FC<PaginationLinksProps> = ({
  nextPageUrl,
  prevPageUrl
}) => {
  const { t } = useTranslation();

  if (!nextPageUrl && !prevPageUrl) return null;

  return (
    <>
      <Head>
        {prevPageUrl && <link rel="prev" href={prevPageUrl} />}
        {nextPageUrl && <link rel="next" href={nextPageUrl} />}
      </Head>
      <nav
        aria-hidden="true"
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          clip: 'rect(0,0,0,0)',
          whiteSpace: 'nowrap'
        }}
      >
        {prevPageUrl && (
          <a rel="prev" href={prevPageUrl}>
            {t('common.previous_page')}
          </a>
        )}
        {nextPageUrl && (
          <a rel="next" href={nextPageUrl}>
            {t('common.next_page')}
          </a>
        )}
      </nav>
    </>
  );
};
